import React from 'react'
import useManageSmartFormEngine from '../hooks/useManageSmartFormEngine'
import DynamicForm from '../../../components/dynamicForm/DynamicForm';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

export default function LayoutSmartFormEngine() {
    const {
        title,
        values,
        errorInputs,
        scheme,
        companyInfo,
        handleInputChange,
        handleDirectInputChange,
        setValuesSelectGeneric,
        handleFileChange,
        loading,
        handleSubmit,
        Cancel
    } = useManageSmartFormEngine();

    return (
        <Box sx={{ mx: 'auto' }}>
            <Card sx={{ mb: 3 }}>
                <CardContent //sx={{ minHeight: '80vh' }}
                >
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                        <Grid size={{ xs: 12 }}>
                            <Typography variant="h6">
                                {title}
                            </Typography>
                        </Grid>
                    </Grid>

                    <DynamicForm
                        values={values}
                        scheme={scheme}
                        errorInputs={errorInputs}
                        onChange={handleInputChange}
                        handleFileChange={handleFileChange}
                        setChanges={handleDirectInputChange}
                        setValuesSelectGeneric={setValuesSelectGeneric}
                        companyInfo={companyInfo}
                        gridConfig={{ columns: 3 }}
                    />

                    <ActionButtons
                        onCancel={Cancel}
                        onSubmit={handleSubmit}
                    />
                </CardContent>
            </Card>
            {/* <DialogSelectCompany
                openDialogConfirm={openDialogCompany}
                handleCancelConfirm={Cancel}
                handleConfirmAction={handleConfirmAction}
                data={companies}
            /> */}
            {
                loading &&
                <LoadingOverlay isOpen={loading} />
            }
        </Box>
    )
}
